function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#5BB749",
  fillRule: "evenodd",
  d: "M6 4.8H2.4V3C2.4 2.0076 3.2076 1.2 4.2 1.2C5.1924 1.2 6 2.0076 6 3V4.8ZM4.8 8.8332V10.2H3.6V8.8332C3.243 8.625 3 8.2422 3 7.8C3 7.1376 3.5376 6.6 4.2 6.6C4.8624 6.6 5.4 7.1376 5.4 7.8C5.4 8.2422 5.157 8.625 4.8 8.8332ZM7.2 4.8V3C7.2 1.3458 5.8542 0 4.2 0C2.5458 0 1.2 1.3458 1.2 3V4.8C0.5376 4.8 0 5.3376 0 6V10.8C0 11.4624 0.5376 12 1.2 12H7.2C7.8624 12 8.4 11.4624 8.4 10.8V6C8.4 5.3376 7.8624 4.8 7.2 4.8Z",
  clipRule: "evenodd"
});

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    fill: "none",
    viewBox: "0 0 9 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.4480db97.svg";
export { ForwardRef as ReactComponent };